import { useMutation } from '@tanstack/react-query';
import { SubmitFeedbackRequest } from '@amzn/fox-den-mec-setting';
import { SettingsApi } from '../settingsApi';

/**
 * This function invokes API to submit and save user feedback.
 * @param SubmitFeedbackRequest Request
 */
export const submitFeedback = (request: SubmitFeedbackRequest) =>
  SettingsApi.submitFeedback(request);

/**
 * React query wrapper to save and submit user feedback.
 */
export const useFeedbackMutation = () =>
  useMutation({
    mutationFn: submitFeedback,
  });